import axios from "axios";
import i18n from "../../../i18n";

const actions = {
  getAllInstructionFolders(context) {
    return axios
      .get("instructionFolder")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  createInstructionFolder(context, value) {
    return axios
      .post("instructionFolder", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.createdMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateInstructionFolder(context, value) {
    return axios
      .put("instructionFolder/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.updatedMessage", {
            name: r.data.name,
          }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteInstructionFolder(context, val) {
    return axios
      .delete("instructionFolder/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.deletedMessage"),
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleInstructionFolder(context, id) {
    return axios
      .get("instructionFolder/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getInstructionFolderCounts(context) {
    return axios
      .get("instructionFolder/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
